import module from 'nominas/nomina/module.js'
import template from './template.html'
import { cloneDeep } from 'lodash'

export class NominasNominaConfiguracionPagosComponent {
  idProyecto
  idNomina
  idTipoPago
  onClose
  especificarTipoCambio = false
  tipoCambioValido = false
  error = null
  data = null
  total = null
  notas = null
  tipoCambio = null
  metodosPago = null
  monedas = null
  bancos = null
  filtro = {
    text: '',
    notas: false,
  }
  errorCuentasNoAutorizadas = false

  constructor ($filter, $q, CatalogoBancos, CatalogoMonedas, CatalogoSatMetodosPago, NominasNominaInformacionTipocambio, NominasNominaConfiguracionPagos) {
    this.$q = $q
    this.CatalogoBancos = CatalogoBancos
    this.CatalogoMonedas = CatalogoMonedas
    this.CatalogoSatMetodosPago = CatalogoSatMetodosPago
    this.NominasNominaInformacionTipocambio = NominasNominaInformacionTipocambio
    this.NominasNominaConfiguracionPagos = NominasNominaConfiguracionPagos
    this.filterBy = $filter('filter')
    this.orderBy = $filter('orderBy')
  }

  $onChanges (changes) {
    if (changes.idProyecto || changes.idNomina || changes.idTipoPago) {
      this.cargar()
    }
  }

  cargar () {
    let promises = [
      this.NominasNominaConfiguracionPagos.get(this.idProyecto, this.idNomina, this.idTipoPago)
        .then(({data}) => {
          data.forEach((item) => {
            item.$$id = `${item.id_dispersion}-${item.beneficiario_id_empresa}-${item.beneficiario_id_empleado}`
            item.cancelable = item.pagos.every((pago) => pago.status_pagado === false)
            item.completado = item.pagos.every((pago) => pago.status_pagado === true)
            item.montoMaximo = (+item.montoMaximo)
            this.errorCuentasNoAutorizadas = !this.errorCuentasNoAutorizadas ? (item.noautorizadoCuenta ? true : false) : true
          })

          this.data = this.orderBy(data, 'beneficiario_nombre')
          this.total = this.data.reduce((total, item) => total + item.total, 0)
          this.notas = this.data.filter((item) => item.cancelable && item.beneficiario_notas).length
        }),
    ]

    if (!this.tipoCambio) {
      promises.push(this.NominasNominaInformacionTipocambio.get(this.idProyecto, this.idNomina)
        .then(({data}) => (this.tipoCambio = data.tipo_cambio)))
    }

    if (!this.metodosPago) {
      promises.push(this.CatalogoSatMetodosPago.get({nomina: true}).then(({data}) => (this.metodosPago = data)))
    }

    if (!this.monedas) {
      promises.push(this.CatalogoMonedas.get().then(({data}) => (this.monedas = data)))
    }

    if (!this.bancos) {
      promises.push(this.CatalogoBancos.get().then(({data}) => (this.bancos = data)))
    }

    this.promise = this.$q.all(promises)
      .then(() => (this.copia = cloneDeep(this.data)))
      .then(() => (this.filtrar()))
  }

  actualizar () {
    if (this.actualizando) return

    this.actualizando = true
    this.error = null

    let data = this.data
      .map((item) => ({
        id_dispersion: item.id_dispersion,
        id_nomina: item.id_nomina,
        id_empresa: item.id_empresa,
        id_empleado: item.id_empleado,
        beneficiario_id_empresa: item.beneficiario_id_empresa,
        beneficiario_id_empleado: item.beneficiario_id_empleado,
        observaciones: item.observaciones,
        status_aprobado: item.status_aprobado,
        pagos: item.pagos,
      }))

    const camposModificables = ['importe', 'banco_clabe', 'banco_cuenta', 'banco_id', 'banco_tarjeta', 'id_metodo_pago', 'id_moneda', 'tipo_cambio']

    data.forEach(item => {
      let dispersionCopia = this.copia.find(element => element.id_dispersion === item.id_dispersion
        && element.beneficiario_id_empleado === item.beneficiario_id_empleado
        && element.beneficiario_id_empresa === item.beneficiario_id_empresa)
      item.pagos.forEach(pago => {
        if (pago.id_pago) {
          let pagoCopia = dispersionCopia.pagos.find(item => item.id_pago === pago.id_pago)
          pago.eliminado = pago.eliminado || pago.importe === 0
          pago.modificado = camposModificables.some((prop) => pagoCopia[prop] !== pago[prop])
        }
      })
    })

    return this.NominasNominaConfiguracionPagos.put(this.idProyecto, this.idNomina, this.idTipoPago, data)
      .then(() => (this.cerrar()))
      .catch(({data}) => (this.error = data))
      .finally(() => (this.actualizando = false))
  }

  actualizarTipoCambio (data) {
    this.especificarTipoCambio = false

    if (data && data.tipoCambio) {
      this.tipoCambio = data.tipoCambio

      this.data.forEach((item) => {
        item.pagos.forEach((pago) => {
          if (!pago.editable || pago.id_moneda === 1) return

          if (pago.tipo_cambio === 1 || data.reemplazar) {
            pago.tipo_cambio = this.tipoCambio
          }
        })
      })
    }
  }

  cerrar () {
    this.onClose({$event: {data: this.idTipoPago}})
  }

  filtrar () {
    let resultados = [...this.data]

    if (this.filtro.notas) {
      resultados = this.data.filter((item) => item.cancelable && !!item.beneficiario_notas)
    }

    if (this.filtro.texto) {
      resultados = this.filterBy(resultados, this.filtro.texto)
    }

    this.resultados = resultados
  }

  validar () {
    this.valido = this.data.every((item) => item.$$valido !== false)
    this.pagosUsd = this.data.some((item) => item.pagos.some((pago) => pago.id_moneda !== 1))
    this.tipoCambioValido = this.data.every((item) => item.pagos.every((pago) => pago.status_pagado || pago.id_moneda === 1 || pago.tipo_cambio > 1))
  }
}

module.component('nominasNominaConfiguracionPagos', {
  controller: NominasNominaConfiguracionPagosComponent,
  template,
  bindings: {
    idProyecto: '<',
    idNomina: '<',
    idTipoPago: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/configuracion/pagos/component.js